import { render } from "./avatar6.vue?vue&type=template&id=298a51c5"
const script = {}

import exportComponent from "/mnt/d/_projects/gitogram/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__